import {
  ApplicationConfig,
  inject,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import {
  getAccessTokenFromStorage,
  provideCeiSsoBootstrap,
} from '@cei-ufg/ngx-cei-sso-client';
import { credenciaisMapper } from './constants/credenciais-mapper';
import {
  Configuration as SegurancaConfiguration,
  CeiSessionRbacSyncService,
  provideCeiAuthorization,
} from '@cei-ufg/ngx-cei-seguranca';
import { provideCeiApiClients } from '@cei-ufg/ngx-arquitetura-cei-commons';
import {
  provideCeiHttpClient,
  provideCeiHttpErrorHandling,
  provideCeiMask,
  provideCeiSessionCountdown,
  provideCeiSobreVersoes,
} from '@cei-ufg/ngx-arquitetura-cei-frontend';
import { Configuration as AppApiConfiguration } from './api';
import {
  ACCESS_TOKEN_KEYS,
  resolveAuthzApiBasePath,
  resolveDomainApiBasePath,
} from './config/runtime-endpoints.utils';
import { versoesFrontendAplicacao } from './config/versoes-aplicacao.config';

const resolveAccessToken = () =>
  getAccessTokenFromStorage([...ACCESS_TOKEN_KEYS], 'localStorage');

registerLocaleData(localePt);

export const appConfig: ApplicationConfig = {
  providers: [
    // Rotas padrão PT: /proibido, /erro-servidor, /nao-encontrado (ver provideCeiAuthorization).
    provideCeiHttpErrorHandling(),
    provideCeiHttpClient(),
    provideCeiMask(),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideCeiSsoBootstrap({
      environment,
      credenciaisPayload: credenciaisMapper,
      accessTokenKeys: ACCESS_TOKEN_KEYS,
      onSessionReady: () => {
        inject(CeiSessionRbacSyncService).start();
      },
    }),
    provideCeiApiClients({
      segurancaConfiguration: SegurancaConfiguration,
      domainConfiguration: AppApiConfiguration,
      resolveDomainBasePath: () => resolveDomainApiBasePath(),
      resolveAuthzBasePath: () => resolveAuthzApiBasePath(),
      resolveAccessToken,
    }),
    provideCeiSessionCountdown({
      config: {
        sessionInfoPath: '/auth/session/',
        sessionTimeSource: 'access_token',
      },
    }),
    provideCeiAuthorization({
      config: { unauthorizedRedirect: '/proibido', unauthenticatedRedirect: '/login', loadErrorRedirect: '/erro-servidor' },
    }),
    provideCeiSobreVersoes({
      versoesFrontend: versoesFrontendAplicacao,
      resolveUrlBaseApi: () => resolveDomainApiBasePath(),
      resolveAccessToken,
    }),
  ],
};
